import { SvgIcon } from '@material-ui/core'

export default function DownChevronIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="2"
                d="m6.725 9 6.052 6 6.051-6"
            />
        </SvgIcon>
    )
}
